<mat-card class="loren-numeric-line-chart-report">
  <div class="loren-numeric-line-chart-report-header">
    <div class="vertically-centered" style="gap: 8px">
      <h3 class="loren-numeric-line-chart-report-title mb-0">
        {{ $safeNavigationMigration(chartsData()?.chartTitle) | transloco }}
      </h3>
    </div>
  </div>

  @if(loading()) {
    <mat-spinner />
  } @else if ((error())) {
  <p>
    {{ "error_page.general_error_message" | transloco }}
  </p>
  } @else if(chartsData().lineChartData) { @if(context() === binary) {
  {{ "chart.aggregate_data_warning" | transloco }}
  @for(item of chartsData().lineChartData; track item) { @if(item.name &&
  item.totalOpen) {
  <div>
    <p class="my-4">
      {{ "asset.counter_open_period" | transloco }} ({{ item.name }}):
      {{ item.totalOpen }}
    </p>
  </div>
  } } }
  <loren-line-chart
    [binary]="context() === binary"
    [binaryContext]="chartsData().binaryContext"
    [chartData]="chartsData().lineChartData"
    [metric]="chartsData().meteringType"
    [showNotes]="allowNotes() && chartsData().showNotes"
    [showMinMax]="context() !== binary && chartsData().showMinMax"
    [yMin]="yMin()"
    [yMax]="yMax()"
    [isHandset]="isHandset()"
    (shouldRefresh)="reloadData()">
  </loren-line-chart>
  @if((context() === numeric && days() > 1) || (allowNotes() && chartHasNotes(chartsData()))) {
  <mat-card-actions>
    @if(context() === numeric && days() > 1) {
    <mat-slide-toggle
      class="loren-numeric-line-chart-report-toggle"
      [checked]="chartsData().showMinMax"
      (change)="toggleShowMinMaxValues()">
      <span class="loren-numeric-line-chart-report-toggle-label">
        {{ "operations.turn_on_min_max_values" | transloco }}
      </span>
    </mat-slide-toggle>
    } @if(allowNotes() && chartHasNotes(chartsData())) {
    <mat-slide-toggle
      class="loren-numeric-line-chart-report-toggle"
      [checked]="chartsData().showNotes"
      (change)="toggleShowNotes()">
      <span class="loren-numeric-line-chart-report-toggle-label">
        {{ "operations.turn_on_notes" | transloco }}
      </span>
    </mat-slide-toggle>
    } </mat-card-actions
  >} } @else {
  <p>{{ "chart.no_data_available" | transloco }}</p>
  }
</mat-card>
